import { Store } from 'redux';

import { FieldServiceRootState } from 'fieldService/domains/FieldServiceRootState';
import rootSaga from 'fieldService/domains/rootSaga';

import configureStore from './configureStore';

export let store: Store<FieldServiceRootState>;

export const buildStore = () => {
  const configuredStore = configureStore();

  store = configuredStore.store;
  configuredStore.runSaga(rootSaga);

  return { store };
};
